// Recovered compiled webpack factory 85396. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  n.d(t, { AT: () => l, MS: () => c, kq: () => u });
  let r = {
      utmSource: "attr_src",
      utmMedium: "attr_med",
      utmCampaign: "attr_cmp",
      utmTerm: "attr_trm",
      utmContent: "attr_cnt",
      referrer: "attr_ref",
      landingPage: "attr_lnd",
    },
    i = ["ultramock.io", "www.ultramock.io", "beta.ultramock.io", "localhost"];
  function a(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 256;
    if (!e) return null;
    let n = e.trim();
    return n ? (n.length > t ? n.slice(0, t) : n) : null;
  }
  let o = null,
    s = !1;
  function l() {
    return s
      ? o
      : ((s = !0),
        (o = (function (e) {
          let t = a(e.searchParams.get("utm_source")),
            n = a(e.searchParams.get("utm_medium")),
            r = a(e.searchParams.get("utm_campaign")),
            o = a(e.searchParams.get("utm_term")),
            s = a(e.searchParams.get("utm_content")),
            l = a(
              (function (e) {
                if (!e) return null;
                try {
                  var t;
                  let n = new URL(e);
                  if (((t = n.hostname), i.includes(t) || t.endsWith(".vercel.app"))) return null;
                  return n.origin;
                } catch {
                  return null;
                }
              })(e.referrer),
            );
          return t || n || r || o || s || l
            ? {
                utmSource: t,
                utmMedium: n,
                utmCampaign: r,
                utmTerm: o,
                utmContent: s,
                referrer: l,
                landingPage: (function (e) {
                  let t = a(e, 128);
                  return !t || !t.startsWith("/") || t.startsWith("//") ? null : t;
                })(e.pathname),
                capturedAt: new Date().toISOString(),
              }
            : null;
        })({
          searchParams: new URLSearchParams(window.location.search),
          referrer: document.referrer || null,
          pathname: window.location.pathname,
        })));
  }
  function c() {
    return l();
  }
  function u() {
    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "/sign-in",
      t = (function (e) {
        let t = new URLSearchParams();
        if (!e) return t;
        for (let [n, i] of [
          [r.utmSource, e.utmSource],
          [r.utmMedium, e.utmMedium],
          [r.utmCampaign, e.utmCampaign],
          [r.utmTerm, e.utmTerm],
          [r.utmContent, e.utmContent],
          [r.referrer, e.referrer],
          [r.landingPage, e.landingPage],
        ])
          i && t.set(n, i);
        return t;
      })(c()).toString();
    return t ? `${e}${e.includes("?") ? "&" : "?"}${t}` : e;
  }
}
